import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var VideoPlaySVG = function VideoPlaySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM17,6h2V9H17ZM13,6h2V9H13ZM7,26H5V23H7ZM7,9H5V6H7Zm4,17H9V23h2ZM11,9H9V6h2Zm4,17H13V23h2Zm4,0H17V23h2Zm.51-9-6.06,3.91A.9.9,0,0,1,13,21a.91.91,0,0,1-.49-.15,1.12,1.12,0,0,1-.48-1V12.1a1.12,1.12,0,0,1,.48-.95.88.88,0,0,1,1,0l6.06,3.91a1.17,1.17,0,0,1,0,1.9ZM23,26H21V23h2ZM23,9H21V6h2Zm4,17H25V23h2ZM27,9H25V6h2Z"
  }));
};
VideoPlaySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(VideoPlaySVG);